import { render, staticRenderFns } from "./WaterCharts.vue?vue&type=template&id=63473189&"
import script from "./WaterCharts.vue?vue&type=script&lang=js&"
export * from "./WaterCharts.vue?vue&type=script&lang=js&"
import style0 from "./WaterCharts.vue?vue&type=style&index=0&id=63473189&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports